import { makeStyles, createStyles, Theme } from '@material-ui/core';
import Colors from '../../components/Colors';

export const optionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      paddingBottom: 50,
      paddingTop: 25,
      marginTop: '15px',
    },
    pageHeader: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '0 30px',
      [theme.breakpoints.down('xs')]: {
        flexDirection: 'column',
      },
    },
    openInNewBtn: {
      backgroundColor: Colors.secundary,
      color: '#404040',
      '&:hover': {
        backgroundColor: Colors.hoverMain,
      },
    },
    cardHeader: {
      backgroundColor: Colors.secundary,
      color: '#404040',
      height: 12,
      width: '100%',
    },
    cardContent: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      width: '100%',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    groupContainer: {
      marginTop: 20,
      display: 'flex',
      flexFlow: 'row',
      width: '100%',
      justifyContent: 'space-around',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        flexFlow: 'column',
      },
    },
    cancelButton: {
      minWidth: 175,
      color: '#e8a300',
      backgroundColor: 'white',
      border: 'none',
    },
    submitButton: {
      minWidth: 175,
      fontFamily: 'Texta Medium',
      backgroundColor: Colors.main,
      color: Colors.white,
      border: 'none',
      '&:hover': {
        fontFamily: 'Texta Heavy',
        backgroundColor: Colors.secundary,
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    button: {
      backgroundColor: Colors.secundary,
      color: '#404040',
      '&:hover': {
        backgroundColor: Colors.hoverMain,
      },
    },
    chartBar: {
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        padding: '3% 0',
      },
      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'space-around',
        padding: '3% 0',
      },
      [theme.breakpoints.up('md')]: {
        display: 'flex',
        flexFlow: 'column',
        justifyContent: 'space-around',
        padding: '3% 0',
      },
      [theme.breakpoints.up('lg')]: {
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'space-around',
        padding: '1% 0',
      },
      alignItems: 'center',
      width: '100%',
      backgroundColor: Colors.secundary,
      padding: '1% 0',
      '& p': {
        color: '#404040',
      },
    },
    rootCardContainer: {
      display: 'flex',
      flexFlow: 'column',
      width: '100%',
      justifyContent: 'space-around',
      backgroundColor: '#f2f2f2',
    },
    containerCard: {
      display: 'flex',
      flexFlow: 'column',
      width: '50%',
      margin: 0,
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    containerCardGroup: {
      display: 'flex',
      flexFlow: 'column',
      width: '47%',
      margin: 0,
      minWidth: 480,
      borderRadius: 5,
      boxShadow: theme.shadows[1],
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    containerCardMap: {
      width: '30%',
      minWidth: 480,
      margin: 0,
      display: 'flex',
      flexFlow: 'column',
      borderRadius: 5,
      padding: 5,
      boxShadow: theme.shadows[1],
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        minWidth: '100%',
      },
    },
    rootCardDate: {
      boxSizing: 'border-box',
      margin: '2% 0',
      width: '100%',
      backgroundColor: '#fff',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
      },
    },
    rootCardModal: {
      boxSizing: 'border-box',
      margin: '2% 0',
      width: '100%',
      overflowY: 'auto',
      backgroundColor: '#fff',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
        background: {},
      },
    },
    formsDiv: {
      display: 'flex',
      flexFlow: 'row',
      width: '90%',
      alignItems: 'center',
      justifyContent: 'space-evenly',
    },
    rootCard: {
      boxSizing: 'border-box',
      margin: '2% 0',
      width: '100%',
      minWidth: 410,
      backgroundColor: '#fff',
      [theme.breakpoints.down('sm')]: {
        minWidth: '100%',
      },
    },
    pageTitle: {
      marginBottom: 20,
    },
    title: {
      [theme.breakpoints.down('sm')]: {
        fontSize: '0.9em',
      },
      [theme.breakpoints.up('sm')]: {
        fontSize: '1em',
      },
      marginTop: '2%',
      color: '#FFFFFF',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: '1em',
      lineHeight: '1.313em',
      fontFamily: 'Roboto',
    },
    containerFormControl: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      padding: 0,
      [theme.breakpoints.down('sm')]: {
        flexFlow: 'column',
        alignItems: 'center',
      },
    },
    column: {
      display: 'flex',
      flexFlow: 'column',
      width: '100%',
      maxHeight: 350,
      overflowY: 'auto',
    },
    columnChild: {
      display: 'flex',
      flexFlow: 'column',
      alignItems: 'center',
      width: '100%',
      maxHeight: 300,
      overflowX: 'hidden',
      overflowY: 'auto',
      [theme.breakpoints.down('sm')]: {
        overflowX: 'auto',
      },
    },
    mapStyle: {
      display: 'flex',
      justifyContent: 'space-between',
      marginTop: '2%',
      width: '95%',
      [theme.breakpoints.down('sm')]: {
        justifyContent: 'space-between',
      },
    },
    formControl: {
      backgroundColor: 'white',
      borderRadius: '5px',
      '&:last-child': {
        marginRight: 0,
      },
      [theme.breakpoints.down('sm')]: {
        marginRight: 0,
      },

      formControlCenter: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
    },
    textField: {
      padding: '0px 8px',
      height: '27px',
      fontFamily: 'Roboto',
      fontSize: '15px',
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      border: '1px solid #f2f2f2',
      backgroundColor: 'white',
      borderRadius: '8px',
      '&:focus': {
        backgroundColor: 'white',
      },
    },
    selectField: {
      padding: '0px 8px',
      width: 150,
      height: '30px',
      fontFamily: 'Roboto',
      fontSize: '15px',
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      border: '1px solid #0c0c0c',
      backgroundColor: 'white',
      borderRadius: '8px',
      '&:focus': {
        backgroundColor: 'white',
      },
    },
    edit: {
      backgroundColor: 'white',
      border: '1px solid black',
      borderRadius: '8px',
      height: '30px',
    },
    remove: {
      border: 'none',
      backgroundColor: 'white',
      height: '30px',
      borderRadius: '8px',
    },
    add: {
      marginTop: '3%',
      backgroundColor: 'white',
      border: 'none',
      alignSelf: 'start',
    },
    addBlocked: {
      marginTop: '3%',
      backgroundColor: 'white',
      border: 'none',
      alignSelf: 'start',
      cursor: 'default',
    },
    label: {
      marginBottom: '10px',
      marginRight: '15px',
      padding: '0px 8px',
      width: '25%',
      height: '30px',
      fontFamily: 'Roboto',
      fontSize: '14px',
      boxShadow: '0px 0px 4px rgba(0, 0, 0, 0.25)',
      border: '1px solid #f2f2f2',
      backgroundColor: 'white',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        minWidth: '26%',
      },
    },
    loadingContainer: {
      display: 'flex',
      marginTop: '30px',
      justifyContent: 'center',
    },
    loadingSpinner: {
      color: Colors.secundary,
    },
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'space-around',
      alignItems: 'center',
      backgroundColor: '#f2f2f2',
      width: '50%',
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
      height: '300px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: '24px',
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
    datePicker: {
      '& .MuiInputBase-root': {
        padding: 0,
        minWidth: 160,
        maxWidth: 200,
        '& .MuiInputBase-input': {
          padding: '0 0 0 15px',
          height: 40,
        },
      },
    },
  }),
);
